import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "slider-right",
  "use": "slider-right-usage",
  "viewBox": "0 0 33 33",
  "content": "<symbol viewBox=\"0 0 33 33\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"slider-right\">\r\n<path d=\"M12.9941 25.6238C12.4629 25.0925 12.4629 24.2312 12.9941 23.6999L20.1944 16.4997L12.9941 9.29945C12.4629 8.7682 12.4629 7.90687 12.9941 7.37561C13.5254 6.84436 14.3867 6.84436 14.918 7.37561L23.0801 15.5378C23.6114 16.069 23.6114 16.9304 23.0801 17.4616L14.918 25.6238C14.3867 26.155 13.5254 26.155 12.9941 25.6238Z\" fill=\"#E2E2E2\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol